var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03893 5L10.2163 13.2596L4 19.9751H5.39916L10.8417 14.0955L15.2389 19.9751H20L13.4749 11.251L19.2611 5H17.8619L12.8498 10.4149L8.8 5H4.03893ZM6.09646 6.03051H8.28367L17.9422 18.9446H15.755L6.09646 6.03051Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterM);
export default __webpack_public_path__ + "static/media/twitter-m.1cd9e66a421c295227d3f6f3e04ee2e8.svg";
export { ForwardRef as ReactComponent };